<template>
  <BaseTableView :head="tableHead" :class="extra && $vuetify.breakpoint.xlOnly ? 'table--extra' : 'table--main'">
    <TimeControlShowEmployeeTableCurentDateItem
      v-for="(period, key) in periods"
      :key="key"
      :period="period"
      :extra="extra"
    />
  </BaseTableView>
</template>

<script>
import TimeControlShowEmployeeTableCurentDateItem
  from 'components/timeControl/showEmployee/TimeControlShowEmployeeTableCurentDateItem'

export default {
  name: 'TimeControlShowEmployeeTableCurentDate',
  props: {periods: Array, extra: Boolean},
  components: {TimeControlShowEmployeeTableCurentDateItem},
  data() {
    return {tableMin: false}
  },
  computed: {
    tableHead() {
      return [
        {
          text: !this.extra
            ? this.localStorage.translations.pages.statistic_employee.tables['vid-rabot']
            : this.localStorage.mobile.pages['mob_working_time-report'].titles[
              'additional_work_type'
              ],
        },
        {
          text: !this.extra || this.$vuetify.breakpoint.lgAndDown
            ? this.localStorage.translations.pages.statistic_employee.tables['fakt']
            : '',
        },
      ]
    },
  },
  methods: {
    onMin(value) {
      this.tableMin = value
    },
  },
  watch: {},
}
</script>

<style lang="scss">

.table {
  &--extra {
    thead {
      tr {
        th {
          background: #dedede !important;
        }
      }
    }
    td {
      &:nth-child(1) {
        width: calc(100% / 3);
      }
      &:nth-child(2) {
        width: calc(100% * 2 / 3);
      }
    }
  }
  &--main {
    td {
      &:nth-child(1) {
        width: calc(100% / 3);
      }
      &:nth-child(2) {
        width: calc(100% * 2 / 3);
      }
    }
  }
}
</style>
